"use strict"

export default function routes($stateProvider) {
  "ngInject"

  $stateProvider
    .state("mainmap.home.availability-pick", {
      url: "/availability/:categorytype/:accomtype/:startdate/:enddate/:shouldpick",
      component: "availabilitycheck",
      resolve: {
        campsiteinfo: function (campsitedata) {
          return campsitedata
        },
      },
    })
    .state("mainmap.home.availability-check-showing", {
      url: "/availability/check",
      component: "availabilitycheck",
      resolve: {
        campsiteinfo: function (campsitedata) {
          return campsitedata
        },
      },
    })
    .state("mainmap.home.availability", {
      url: "/availability/:categorytype/:accomtype/:startdate/:enddate",
      component: "availabilitycheck",
      resolve: {
        campsiteinfo: function (campsitedata) {
          return campsitedata
        },
      },
    })
    .state("mainmap.home.availability-with-occupancy", {
      url: "/availability/:categorytype/:accomtype/:startdate/:enddate/:numofadults/:numofchildren/:numofinfants",
      component: "availabilitycheck",
      resolve: {
        campsiteinfo: function (campsitedata) {
          return campsitedata
        },
      },
    })
}
